import { BASE_URL, JWT_APP_ID } from '../../config/URL';
import axios from 'axios';
import { showToastNotif } from './notification';
import analytic, {
  analyticEvents,
  analyticTypes,
} from '../../service/analytic';
import { authPopup } from './auth';
import { configKeys, remoteConfig } from '../../service/firebase';

const BASE_CONFIG_URL = remoteConfig
  .getValue(configKeys.userApiBaseUrl)
  .asString();

const publicProfileURL = `${BASE_CONFIG_URL}/user/v1.1/profile`;
const playlistURL = `${BASE_URL}/catalog/v1.1/playlists`;

export const getPublicProfile = (profileId) => async (dispatch, getState) => {
  const state = getState();
  const userToken = state.auth.token;
  const userId = state.auth.user ? state.auth.user.profile.id : null;
  const accountId = state.auth.user ? state.auth.user.profile.accountId : null;
  const url = userId
    ? `${publicProfileURL}/${profileId}/public?viewerId=${userId}&accountId=${accountId}`
    : `${publicProfileURL}/${profileId}/public`;

  dispatch({
    type: 'GET_PUBLIC_PROFILE',
  });

  try {
    const res = await axios.get(url, {
      headers: {
        Authorization: userToken,
        'Cloudfront-JWT-AppId': JWT_APP_ID,
      },
    });

    dispatch({
      type: 'SET_PUBLIC_PROFILE',
      payload: res.data.data,
      err: false,
    });
    return res.data.data;
  } catch (err) {
    // const errorData = generateErrorDetail(err);
    dispatch({
      type: 'GET_PUBLIC_PROFILE_FAILED',
      err: err,
    });
  }
};

export const getRecordedLiveShow =
  (profileId, page, perPage) => async (dispatch, getState) => {
    dispatch({
      type: 'GET_RECORDED_LIVESHOW',
    });
    try {
      const res = await axios.get(
        `${playlistURL}/getByProfileId?locale=en&profileId=${profileId}&page=${page}&perPage=${perPage}`,
        {
          headers: {
            'Cloudfront-JWT-AppId': JWT_APP_ID,
          },
        }
      );

      dispatch({
        type: 'GET_RECORDED_LIVESHOW_SUCCESS',
        payload: res.data,
        page,
      });
    } catch (err) {
      dispatch({
        type: 'GET_RECORDED_LIVESHOW_FAILED',
        err,
      });
    }
  };

export const getClipsByProfileId =
  (profileId, page, perPage, clipsID) => async (dispatch, getState) => {
    dispatch({
      type: 'GET_CLIPS',
    });
    try {
      const res = await axios.get(
        `${BASE_URL}/catalog/v1.1/playlist/${clipsID}/clipsItemsByProfileId?locale=en&profileId=${profileId}&page=${page}&perPage=${perPage}`,
        {
          headers: {
            'Cloudfront-JWT-AppId': JWT_APP_ID,
          },
        }
      );

      dispatch({
        type: 'GET_CLIPS_SUCCESS',
        payload: res.data,
        page,
      });
    } catch (err) {
      dispatch({
        type: 'GET_CLIPS_FAILED',
        err,
      });
    }
  };

export const getFollowerList =
  (profileId, type, page = 1, perPage = 10) =>
  async (dispatch, getState) => {
    const state = getState();

    dispatch({
      type: 'GET_FOLLOWER_LIST',
    });

    try {
      const res = await axios.get(
        `${publicProfileURL}/${profileId}/relations`,
        {
          headers: {
            Authorization: state.auth.token,
            'Cloudfront-JWT-ProfileId': JWT_APP_ID,
          },
          params: {
            page,
            perPage,
            type,
          },
        }
      );

      if (type === 'followers') {
        dispatch({
          type: 'SET_FOLLOWERS',
          payload: res.data,
          page,
        });
      }
      if (type === 'following') {
        dispatch({
          type: 'SET_FOLLOWING',
          payload: res.data,
          page,
        });
      }
    } catch (err) {
      const error =
        err.response && err.response.data && err.response.data.error;

      if (type === 'followers') {
        dispatch({
          type: 'GET_FOLLOWERS_FAILED',
          err: error,
        });
      }
      if (type === 'following') {
        dispatch({
          type: 'GET_FOLLOWINGS_FAILED',
          err: error,
        });
      }
    }
  };

export const resetFollowList = () => (dispatch) => {
  dispatch({
    type: 'RESET_FOLLOW_LIST',
  });
};

export const handleUserRelation =
  (publicProfile, streamerProfile = true) =>
  async (dispatch, getState) => {
    const state = getState();
    const { token } = state.auth;
    const relationId = publicProfile?.profile?.profileRelationId;
    const streamerId = publicProfile?.profile?.id;

    if (!token) {
      localStorage.setItem('gfRedirectPath', window.location.pathname);
      return dispatch(authPopup.show());
    }

    let res;
    if (publicProfile) {
      res = publicProfile.relation.isFollowing
        ? await dispatch(unfollowUser(relationId))
        : await dispatch(followUser(streamerId));
    }
    if (streamerProfile) dispatch(getPublicProfile(streamerId));
    return res;
  };

export const followUser = (profileId) => async (dispatch, getState) => {
  const state = getState();
  const user = state.auth.user;
  const profile = state.publicProfile.profile;

  dispatch({
    type: 'SET_FOLLOW_STATUS',
  });

  try {
    const response = await axios.post(
      `${BASE_CONFIG_URL}/user/v1.0/relations`,
      `profileId=${profileId}`,
      {
        headers: {
          Authorization: state.auth.token,
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cloudfront-JWT-AppId': JWT_APP_ID,
        },
      }
    );

    dispatch({
      type: 'FOLLOW_USER_SUCCESS',
    });

    const paramsEvent = {
      followedUser: profile,
    };
    analytic(analyticTypes.event, analyticEvents.PUBLIC_PROFILE.FOLLOW_USER, {
      params: paramsEvent,
      user,
    });
    return response?.status;
  } catch (err) {
    dispatch({
      type: 'FOLLOW_USER_FAILED',
      err,
    });
    dispatch(showToastNotif('error', 'Failed to follow user'));
    return err?.response?.status;
  }
};

export const unfollowUser = (relationId) => async (dispatch, getState) => {
  const state = getState();
  const user = state.auth.user;
  const profile = state.publicProfile.profile;

  dispatch({
    type: 'SET_FOLLOW_STATUS',
  });

  try {
    const response = await axios.delete(
      `${BASE_CONFIG_URL}/user/v1.0/relation/${relationId}`,
      {
        headers: {
          Authorization: state.auth.token,
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cloudfront-JWT-AppId': JWT_APP_ID,
        },
      }
    );

    dispatch({
      type: 'UNFOLLOW_USER_SUCCESS',
    });

    const paramsEvent = {
      relationId,
      unfollowedUser: profile,
    };
    analytic(analyticTypes.event, analyticEvents.PUBLIC_PROFILE.UNFOLLOW_USER, {
      params: paramsEvent,
      user,
    });
    return response?.status;
  } catch (err) {
    dispatch({
      type: 'UNFOLLOW_USER_FAILED',
      err,
    });
    dispatch(showToastNotif('error', 'Failed to unfollow user'));
    return err?.response?.status;
  }
};
